//
//
//
//
//
//
//
//

import ComStep from "@/0/components/comStep/comStep";
export default {
  components: {
    "com-step": ComStep
  },
  props: ["dataConfig"],
  data() {
    return {

      ActiveIndex:0,
      StepList:[],      
      
    };
  },
  created() {
    console.log("this.dataConfig",this.dataConfig);
    if(!this.dataConfig) return;

    this.ActiveIndex = this.dataConfig.ActiveIndex;
    this.StepList = this.dataConfig.StepList.map(m=>{
      return m.CellContent;
    });    

  },

  methods: {
    
    
  }
};
